<section>
  <button type="button" class="btn btn-back d-flex align-items-center py-5" [routerLink]="['/office-lease/tenant-list']"
    routerLinkActive="router-link-active">
    <img src="assets/icons/arrow-left.png"> <span class="mx-4">Back</span>
  </button>

  <div class="container-fluid py-4 px-4">
    <div class="container-card mb-4">
      <h5 class="heading-1 my-4">Business Unit Detail</h5>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-2 d-flex justify-content-center align-items-center">
          <div class="box-container-image">
            <img [src]="tenantImageUrl" class="img-fluid">
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-5 my-3 my-lg-0">
          <div class="business-details-card">
            <div class="row g-0 h-100">
              <div class="col-6 col-md-6 col-lg-6">
                <div class="d-flex flex-column mb-0 h-100 justify-content-between">
                  <span class="unit-title-bold">Business Unit Name</span>
                  <span class="unit-title-bold">Company Reference</span>
                  <span class="unit-title-bold">Tenant Type</span>
                  <span class="unit-title-bold">Total Floor Used</span>
                  <span class="unit-title-bold">Total Persons</span>
                  <span class="unit-title-bold">Total Area Used</span>
                  <span class="unit-title-bold">Deposit Amount</span>
                </div>
              </div>
              <div class="col-6 col-md-6 col-lg-6">
                <div class="d-flex flex-column mb-0 h-100 justify-content-between text-end">
                  <span class="unit-title">{{ itemTenantDetail.name }}</span>
                  <span class="unit-title">{{ itemTenantDetail.company_reference }}</span>
                  <span class="unit-title">{{ itemTenantDetail.type }}</span>
                  <span class="unit-title">{{ itemTenantDetail.floor_used }}</span>
                  <span class="unit-title">{{ itemTenantDetail.total_employee }}</span>
                  <span class="unit-title">{{ itemTenantDetail.area_used | squareMeter}}</span>
                  <span class="unit-title">{{ itemTenantDetail.deposit_amt | rupiah }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-5">
          <div class="card container-contract">
            <div class="card-header bg-transparent border-0 pt-2 pb-0">
              <h5 class="mb-0 mx-2">Contract Reference</h5>
            </div>

            <div class="card-body container-unit-contract py-2">
              <div class="row g-0" *ngFor="let item of itemTenantDetail.contract_references">
                <div class="col-8 col-md-8 col-lg-8">
                  <div class="d-flex flex-column mb-0">
                    <div class="contract-item">
                      <img src="assets/icons/file.png" alt="" class="contract-icon">
                      <span class="contract-title-bold ms-2">{{ item.contract_ref }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-4 col-md-4 col-lg-4">
                  <div class="d-flex flex-column mb-0 align-items-end">
                    <div class="contract-item">
                      <span class="contract-title">{{ item.area_used }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid py-4 px-4">
    <div class="container-card mb-4">

      <!-- ----- Mobile Responsive ------->

      <div class="row d-block d-md-none d-lg-none">
        <div class="col-12 col-md-6 col-lg-6">
          <h1 class="heading-1">List Building</h1>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <div class="d-flex justify-content-end">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-7">
                <div class="form-group group-input">
                  <input type="text" class="form-control search-input" placeholder="Type Building Name or Floor Number"
                    [(ngModel)]="searchTerm" (keyup)="onSearch($event)" [value]="searchTerm">
                  <img src="assets/icons/search.png" alt="">
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4 mt-3 mt-md-0 mt-lg-0">
                <div class="custom-dropdown">
                  <div class="dropdown">
                    <button class="btn btn-contract" data-bs-toggle="dropdown" aria-expanded="false"
                      data-bs-auto-close="outside">
                      All Contract <i class="fa-solid fa-chevron-down fa-xs"></i>
                    </button>

                    <ul class="dropdown-menu show-custom p-4">
                      <li>
                        <a class="dropdown-item">
                          All Contract
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!---------- Desktop Responsive -------->

      <div class="row row d-none d-md-block d-lg-block">
        <div class="d-flex justify-content-between">
          <div class="p-2 flex-grow-1">
            <h1 class="heading-1">List Building</h1>
          </div>
          <div class="p-2">
            <div class="form-group group-input">
              <input type="text" class="form-control search-input" placeholder="Type Building Name or Floor Number"
                [(ngModel)]="searchTerm" (keyup)="onSearch($event)" [value]="searchTerm">
              <img src="assets/icons/search.png" alt="">
            </div>
          </div>
          <!--<div class="p-2">
            <div class="custom-dropdown">
              <div class="dropdown">
                <button class="btn btn-outlet-success-custom w-100" data-bs-toggle="dropdown" aria-expanded="false"
                  data-bs-auto-close="outside">
                  {{ selectedContractType || 'All Contract Type' }}
                  <i class="fa-solid fa-chevron-down fa-xs"></i>
                </button>

                <ul #dropdownMenu class="dropdown-menu show-custom p-4">
                  <li>
                    <a class="dropdown-item" (click)="resetContractTypeFilter()"
                      [class.active]="selectedContractType === 'All Contract Type'">
                      All Contract Type
                    </a>
                  </li>

                  <li *ngFor="let item of itemTenantContractType">
                    <a class="dropdown-item" (click)="onContractTypeFilter(item.contract_ref, item.area_used)"
                      [class.active]="selectedContractType === item.area_used">
                      {{ item.contract_ref }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>-->
        </div>

      </div>

      <div class="table-responsive my-3 p-0 d-none d-lg-block">
        <table class="table table-striped text-nowrap">
          <thead>
            <tr>
              <th class="text-center sortable-header" (click)="onSort('building')">
                <span>Building</span>
                <i [class]="getSortIcon('building')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header">
                <span>Floor</span>
              </th>
              <th class="text-center sortable-header">
                <span>Id Contract</span>
              </th>
              <th class="text-center sortable-header" (click)="onSort('status')">
                <span>Status</span>
                <i [class]="getSortIcon('status')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('usage_area')">
                <span>Usage Area</span>
                <i [class]="getSortIcon('usage_area')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('contract_exp_date')">
                <span>Contract Expiry</span>
                <i [class]="getSortIcon('contract_exp_date')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('monthly_revenue')">
                <span>Monthly Revenue</span>
                <i [class]="getSortIcon('monthly_revenue')" class="sort-icon"></i>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="!isLoading && itemTenant.length > 0">
            <tr *ngFor="let item of itemTenant">
              <td class="text-start" [routerLink]="['/office-lease/detail-office-lease', item.id_building]"
                routerLinkActive="active">
                {{ item.building }}
              </td>
              <td class="text-center">{{ item.floor }}</td>
              <td class="text-center">{{ item.id_contract }}</td>
              <td class="text-center">
                <div [ngSwitch]="item.status">
                  <span *ngSwitchCase="'Expired'" class="badge badge-partially-occupied">{{
                    item.status }}</span>
                  <span *ngSwitchCase="'Active'" class="badge badge-fully-occupied">{{ item.status
                    }}</span>
                  <span *ngSwitchDefault>{{ item.status }}</span>
                </div>
              </td>
              <td class="text-center">{{ item.usage_area | squareMeter }}</td>
              <td class="text-center">{{ item.contract_exp_date | dateformat }}</td>
              <td class="text-end">{{ item.monthly_revenue | rupiah }}</td>
            </tr>

          </tbody>
          <tbody *ngIf="isLoading">
            <tr>
              <td colspan="7" class="text-center">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-sm-block d-md-block d-lg-none">

        <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}" role="button" tabindex="0"
          *ngFor="let item of itemTenant; let i = index"
          [routerLink]="['/office-lease/detail-office-lease', item.id_building]">
          <div class="card-header card-sm-header">
            <h5>{{ item.building }}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-5">
                <div class="card-sm-title mt-2">Floor</div>
                <div class="card-sm-title mt-2">Status</div>
                <div class="card-sm-title mt-2">Available Area</div>
                <div class="card-sm-title mt-2">Contract Expiry</div>
                <div class="card-sm-title mt-2">Monthly Revenue</div>
              </div>
              <div class="col-7">
                <div class="card-sm-title mt-2">{{ item.floor }}</div>
                <div class="card-sm-title mt-2">
                  <div [ngSwitch]="item.status">
                    <span *ngSwitchCase="'Expired'" class="badge badge-partially-occupied">{{
                      item.status }}</span>
                    <span *ngSwitchCase="'Active'" class="badge badge-fully-occupied">{{ item.status
                      }}</span>
                    <span *ngSwitchDefault>{{ item.status }}</span>
                  </div>
                </div>
                <div class="card-sm-title mt-2">{{ item.usage_area | squareMeter }}</div>
                <div class="card-sm-title mt-2">{{ item.contract_exp_date | dateformat }}</div>
                <div class="card-sm-title mt-2">{{ item.monthly_revenue | rupiah }}</div>
              </div>
            </div>
          </div>

          <div class="card-body d-flex justify-content-center" *ngIf="isLoading">
            <div class="spinner-border text-success text-center" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-12 col-md-12 col-lg-6 total-page-number">
          <h5 class="pageCount">
            Displaying
            <span class="perPage">
              {{ displayRange.start | number }} - {{ displayRange.end | number }}
            </span>
            out of
            <span class="totalPerPage">
              {{ displayRange.total | number }}
            </span>
          </h5>
        </div>

        <div class="col-12 col-md-12 col-lg-6 page-pagination">

          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link first-page" href="javascript:void(0)" (click)="onFirstPage()" aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link prev-page" href="javascript:void(0)" (click)="onPrevPage()" aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pageNumbers"
                [class.active]="page === paginationConfig.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link next-page" href="javascript:void(0)" (click)="onNextPage()" aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link last-page" href="javascript:void(0)" (click)="onLastPage()" aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>

        </div>
      </div>
    </div>
  </div>

</section>